import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=87f572f4&scoped=true&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=87f572f4&scoped=true&lang=css&"
import style1 from "./AppLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f572f4",
  null
  
)

export default component.exports